/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import {
  GetEventFacetsPayload,
  GetEventFacetsPayload$Outbound,
  GetEventFacetsPayload$outboundSchema,
} from "../components/geteventfacetspayload.js";

export type GetEventFacetsSecurity = {
  sessionHeaderGramSession?: string | undefined;
};

export type GetEventFacetsRequest = {
  /**
   * Session header
   */
  gramSession?: string | undefined;
  getEventFacetsPayload: GetEventFacetsPayload;
};

/** @internal */
export type GetEventFacetsSecurity$Outbound = {
  "session_header_Gram-Session"?: string | undefined;
};

/** @internal */
export const GetEventFacetsSecurity$outboundSchema: z.ZodMiniType<
  GetEventFacetsSecurity$Outbound,
  GetEventFacetsSecurity
> = z.pipe(
  z.object({
    sessionHeaderGramSession: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      sessionHeaderGramSession: "session_header_Gram-Session",
    });
  }),
);

export function getEventFacetsSecurityToJSON(
  getEventFacetsSecurity: GetEventFacetsSecurity,
): string {
  return JSON.stringify(
    GetEventFacetsSecurity$outboundSchema.parse(getEventFacetsSecurity),
  );
}

/** @internal */
export type GetEventFacetsRequest$Outbound = {
  "Gram-Session"?: string | undefined;
  GetEventFacetsPayload: GetEventFacetsPayload$Outbound;
};

/** @internal */
export const GetEventFacetsRequest$outboundSchema: z.ZodMiniType<
  GetEventFacetsRequest$Outbound,
  GetEventFacetsRequest
> = z.pipe(
  z.object({
    gramSession: z.optional(z.string()),
    getEventFacetsPayload: GetEventFacetsPayload$outboundSchema,
  }),
  z.transform((v) => {
    return remap$(v, {
      gramSession: "Gram-Session",
      getEventFacetsPayload: "GetEventFacetsPayload",
    });
  }),
);

export function getEventFacetsRequestToJSON(
  getEventFacetsRequest: GetEventFacetsRequest,
): string {
  return JSON.stringify(
    GetEventFacetsRequest$outboundSchema.parse(getEventFacetsRequest),
  );
}
